/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportBusinessResponseItem } from './ImportBusinessResponseItem';
import {
    ImportBusinessResponseItemFromJSON,
    ImportBusinessResponseItemFromJSONTyped,
    ImportBusinessResponseItemToJSON,
    ImportBusinessResponseItemToJSONTyped,
} from './ImportBusinessResponseItem';

/**
 * 
 * @export
 * @interface ImportBusinessResponse
 */
export interface ImportBusinessResponse {
    /**
     * 
     * @type {Array<ImportBusinessResponseItem>}
     * @memberof ImportBusinessResponse
     */
    results?: Array<ImportBusinessResponseItem>;
}

/**
 * Check if a given object implements the ImportBusinessResponse interface.
 */
export function instanceOfImportBusinessResponse(value: object): value is ImportBusinessResponse {
    return true;
}

export function ImportBusinessResponseFromJSON(json: any): ImportBusinessResponse {
    return ImportBusinessResponseFromJSONTyped(json, false);
}

export function ImportBusinessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportBusinessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(ImportBusinessResponseItemFromJSON)),
    };
}

export function ImportBusinessResponseToJSON(json: any): ImportBusinessResponse {
    return ImportBusinessResponseToJSONTyped(json, false);
}

export function ImportBusinessResponseToJSONTyped(value?: ImportBusinessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(ImportBusinessResponseItemToJSON)),
    };
}

